export const ICON_GRID = 24

export const ICON_STROKE = 1.5

export const ICON_SIZES = { xs: 12, sm: 16, md: 20, lg: 24, xl: 32 } as const

export type IconSize = keyof typeof ICON_SIZES

export const iconPixels = (size: IconSize | number): number =>
  typeof size === 'number' ? size : ICON_SIZES[size]

/**
 * The stroke width in grid units for an icon of `size`. Above the `xl` size the line
 * keeps the weight it has at `xl`, so a large icon stays a line drawing. An icon with
 * no size has the grid stroke: the renderer does not know its pixels.
 */
export const iconStrokeWidth = (size: IconSize | number | undefined): number => {
  if (size === undefined) {
    return ICON_STROKE
  }

  const pixels = iconPixels(size)

  return pixels <= ICON_SIZES.xl ? ICON_STROKE : (ICON_STROKE * ICON_SIZES.xl) / pixels
}
